/* eslint-disable react/prop-types */
import React, { useState, useEffect, createRef, useRef } from "react";
import withRouter from "../WithRouter";
import axios from "axios";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Navigate, Link } from "react-router-dom";
import { isAuthenticated } from "./services/auth"; //import auth
//Images and Icons
import {
  MdOutlineCancel,
  MdAddCircle,
  MdManageSearch,
  MdModeEdit,
} from "react-icons/md";
// Subcomponents
import CreateClassForm from "./page-parts/CreateClassForm";
import CreateBlockForm from "./page-parts/CreateBlockForm";
import VenueEditForm from "./page-parts/VenueEditForm";
// Common
import StatusBlock from "../common/StatusBlock";
import FadeIn from "../common/FadeIn";
//TimeRendering
import Moment from "react-moment";
import BulkHideOrView from "./page-parts/BulkHide";

const Venue = (props) => {
  const [venue, setVenue] = useState([]);
  const [classesAtVenue, setClassesAtVenue] = useState([]);
  const [blocksAtVenue, setBlocksAtVenue] = useState([]);
  const [classTypes, setClassTypes] = useState([]);
  const [viewMode, setViewMode] = useState("view");
  // Error Handling States
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  // Set the VenueID from params (withRouter element is source)
  const venueID = props.params._id;
  const prevVenueId = useRef(); //Reference the previous Venue ID to ensure new get request if it changes.

  // Get the Venue Details and set them.
  useEffect(async () => {
    prevVenueId.current = venueID; // Assign Refs Value to current load
    // Get the Venue Info
    const venueRequest = await axios.get(`/api/admin/manage/venue/${venueID}`, {
      withCredentials: true,
    });
    // Get the Class Types for adding Classes sent as prop
    const classTypesRequest = await axios.get(`/api/admin/manage/class_types`, {
      withCredentials: true,
    });
    setClassTypes(classTypesRequest.data);
    setClassesAtVenue(venueRequest.data.Classes);
    setBlocksAtVenue(venueRequest.data.BlockClasses);
    return setVenue(venueRequest.data);
  }, [venueID]);

  //Fetch New Data if there's a successful change.
  const fetchNewData = async () => {
    const venueRequest = await axios.get(`/api/admin/manage/venue/${venueID}`, {
      withCredentials: true,
    });
    setBlocksAtVenue(venueRequest.data.BlockClasses);
    setClassesAtVenue(venueRequest.data.Classes);
    return setVenue(venueRequest.data);
  };

  // CreateRef to handle Alerts and scroll
  const alerts = createRef();
  const scrollSmoothHandler = () => {
    return alerts.current.scrollIntoView({ behavior: "smooth" });
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className="Venue">
      {isAuthenticated() ? (
        <FadeIn delay={250} duration={450}>
          <Container>
            <Row className="mt-4 mb-2 text-center">
              <Col sm="12">
                <h1>{venue.VenueName}</h1>
                <span>
                  <strong>{venue.VenueAddress}</strong>
                </span>
                <div ref={alerts}>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm="12" className="text-center">
                <ViewModeButtons
                  setViewMode={setViewMode}
                  viewMode={viewMode}
                />
              </Col>
            </Row>
            {viewMode === "view" && classesAtVenue.length > 0 && (
              <ClassTiles classesAtVenue={classesAtVenue} />
            )}
            {viewMode === "view" && blocksAtVenue.length > 0  && (
              <BlockTiles blocksAtVenue={blocksAtVenue} />
            )}
            {viewMode === "view" && (blocksAtVenue.length > 0 || classesAtVenue.length > 0 ) && (
              <BulkHideOrView
                setSuccessMessage={setSuccessMessage}
                setErrorMessage={setErrorMessage}
                fetchNewData={fetchNewData}
                scrollSmoothHandler={scrollSmoothHandler}
                venueID={venueID}
              />
            )}
            {viewMode === "add" && (
              <CreateClassForm
                venueID={venueID}
                VenueName={venue.VenueName}
                fetchNewData={fetchNewData}
                scrollSmoothHandler={scrollSmoothHandler}
                setSuccessMessage={setSuccessMessage}
                setErrorMessage={setErrorMessage}
                classTypes={classTypes}
              />
            )}
            {viewMode === "addBlock" && (
              <CreateBlockForm
                venueID={venueID}
                fetchNewData={fetchNewData}
                scrollSmoothHandler={scrollSmoothHandler}
                setSuccessMessage={setSuccessMessage}
                setErrorMessage={setErrorMessage}
                classTypes={classTypes}
              />
            )}
            {viewMode === "edit" && (
              <VenueEditForm
                venue={venue}
                fetchNewData={fetchNewData}
                venueID={venueID}
                scrollSmoothHandler={scrollSmoothHandler}
                setSuccessMessage={setSuccessMessage}
                setErrorMessage={setErrorMessage}
                setViewMode={setViewMode}
              />
            )}
          </Container>
        </FadeIn>
      ) : (
        <Navigate to="/admin/" />
      )}
    </div>
  );
};

const ClassTiles = (props) => {
  //Sort the classes
  const daySorter = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };

  const classesAtVenue = props.classesAtVenue
    .sort((a, b) => {
      return a.StartTime.localeCompare(b.StartTime);
    })
    .sort(function sortByDay(a, b) {
      let day1 = a.Day;
      let day2 = b.Day;
      return daySorter[day1] - daySorter[day2];
    });
  return (
    <Row className="mb-4">
      {classesAtVenue.length > 0 && (
        <h2 className="text-center mt-2 mb-2">Regular Bookings</h2>
      )}
      {classesAtVenue.map((classAtVenue) => (
        <Col key={classAtVenue._id} sm="6" lg="3">
          <div className="shadow m-3 p-3 text-center classTile border">
            <h6>{classAtVenue.LessonType}</h6>
            <p>
              <span>
                {classAtVenue.StartTime +
                  " - " +
                  classAtVenue.FinishTime +
                  " on " +
                  classAtVenue.Day}
              </span>
              <hr />
              <span>
                {classAtVenue.Subscribers_Number}/{classAtVenue.MaxLearners}{" "}
                spaces
              </span>
              <hr />
              <span>{classAtVenue.WaitingListSize} waiting</span>
            </p>
            <Button
              size="sm"
              variant="primary"
              as={Link}
              to={`/admin/classes/${classAtVenue._id}`}
            >
              <MdManageSearch /> Manage
            </Button>
          </div>
        </Col>
      ))}
    </Row>
  );
};

const BlockTiles = (props) => {
  const blocksAtVenue = props.blocksAtVenue.sort((a, b) => {
    return a.Dates[0].localeCompare(b.Dates[0]);
  });
  return (
    <Row className="mb-4">
      {blocksAtVenue.length > 0 && (
        <h2 className="text-center mt-2 mb-2">Block Bookings</h2>
      )}
      {blocksAtVenue.map((block) => (
        <Col key={block._id} sm="6" lg="3">
          <div className="shadow m-3 p-3 text-center classTile border">
            <h6>{block.LessonType}</h6>
            <p>
              <span>
                1st Date:{" "}
                <Moment format="ddd DD MMMM, h:mm A">{block.Dates[0]}</Moment>
              </span>
              <hr />
              <span>
                {block.Subscribers_Number}/{block.MaxLearners} spaces
              </span>
            </p>
            <Button
              size="sm"
              variant="primary"
              as={Link}
              to={`/admin/blocks/${block._id}`}
            >
              <MdManageSearch /> Manage
            </Button>
          </div>
        </Col>
      ))}
    </Row>
  );
};

const ViewModeButtons = (props) => {
  if (
    props.viewMode === "add" ||
    props.viewMode === "edit" ||
    props.viewMode === "addBlock"
  ) {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant="secondary"
          value="view"
          className="m-1"
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdOutlineCancel />
          Return
        </Button>
      </FadeIn>
    );
  } else {
    return (
      <FadeIn delay={50} duration={450}>
        <Button
          variant="primary"
          value="add"
          className="m-1"
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdAddCircle />
          Add Regular
        </Button>
        <Button
          variant="info"
          value="edit"
          className="m-1"
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdModeEdit />
          Edit Venue
        </Button>
        <Button
          variant="success"
          value="addBlock"
          className="m-1"
          onClick={(e) => props.setViewMode(e.target.value)}
        >
          <MdAddCircle />
          Add Block
        </Button>
      </FadeIn>
    );
  }
};

export default withRouter(Venue);
